export default __webpack_public_path__ + "static/flipSectionBg-759403a3035aa66ada1ec65d56cf5782.png";